import(/* webpackMode: "eager" */ "/opt/build/repo/animations/FadeUpOnVisible.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/ledventure-12.webp");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/ledventure-service02.webp");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/ledventure-service03.webp");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/ledventure-service04.webp");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/ledventure-service05.webp");
